<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="purchasing-actions-snackbar">
    <div>
      <CopyItem
        v-if="showActions.copyItem"
        :copy-item="$_copyApp"/>
    </div>
    <div>
      <ToggleTemplates
        v-if="showActions.template"
        :add="!inTemplates.length"
        @click="toTemplate"/>
    </div>
    <div>
      <sButton
        v-if="showActions.remove"
        class="px-2"
        color="var(--white-color)"
        data-qa="btn-purchasing-remove"
        icon="delete"
        type="text"
        @click="removeApps">
        {{ $t('Purchasing.Remove') }}
      </sButton>
    </div>
  </div>
</template>
<script>
import CopyItem from 'components/common/elements/CopyItem.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'

import { applicationMixin, filterSortMixin } from 'mixins'

export default {
  mixins: [ filterSortMixin, applicationMixin ],
  name: 'purchasingActionsToolbar',
  props: {
    options: Object,
    reject_condition: Boolean
  },
  computed: {
    showActions() {
      const result = {
        copyItem: this.elements.length == 1,
        template: !this.inTemplates || !this.inTemplates.length || (this.inTemplates.length == this.elements.length),
        remove: this.first.status == 'П',
        toolbar: false,
      }

      result.toolbar = !!Object.values(result)?.filter(i => i)?.length
      this.$emit('showActions', result)
      return result
    },
    first() {
      return this.elements[0] || {}
    },
    elements() {
      let elems = this.options.elements || []
      this.$emit('update:reject_condition', !!elems && elems.length > 1 )
      return elems
    },
    inTemplates() {
      return this.elements.filter(el => el.inTemplates)
    },
  },
  methods: {
    toTemplate() {
      if (!this.inTemplates?.length) {
        this.saveItemswAsTemplate(this.elements)
      } else {
        this.deleteItemsFromTemplate(this.elements, this.inTemplates)
      }
      this.options.rejectChoosed()
    },
  },
  components: {
    CopyItem,
    ToggleTemplates
  }
}
</script>
